<template>
  <div class="assessment">
    <div class="assessment_header">球员评估</div>
    <el-table
      class="table"
      :data="evalData"
      header-row-class-name="table-header"
    >
      <template #empty>
        <div style="height: 240px">
          <cl-no-data></cl-no-data>
        </div>
      </template>
      <el-table-column prop="name" label="模板名称"></el-table-column>
      <el-table-column prop="score" label="得分">
        <template #default="{ row }">
          <span class="table-score">{{ row.score ?? "N/A" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="评分时间">
        <template #default="{ row }">
          <span class="table-date">{{ row.date }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    evalData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "../common-style.scss";

.table {
  min-height: 240px;
}
</style>
